// ** Auth Endpoints
export default {
  // loginEndpoint: 'http://localhost:8001/api/login',
  loginEndpoint: 'https://apiprd.nobreimagens.com.br/api/login', //PRODUÇÃO
  // loginEndpoint: 'https://api.nobreimagens.com.br/api/login', //PRODUÇÃO
  //loginEndpoint: 'http://localhost:8001/login', //LOCAL

  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // baseApi: 'http://localhost:8001/', //LOCAL
  baseApi: 'https://apiprd.nobreimagens.com.br/', //PRODUÇÃO
  //  baseApi: 'https://api.nobreimagens.com.br/', //PRODUCAO

  // apiEndpoint: 'http://localhost:8001/api', 
  apiEndpoint: 'https://apiprd.nobreimagens.com.br/api', //PRODUÇÃO
  //  apiEndpoint: 'https://api.nobreimagens.com.br/api', //PRODUÇÃO
  //apiEndpoint: 'http://localhost:8001', //LOCAL

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'sessionToken',
  storageRefreshTokenKeyName: 'sessionTokenexpiration'
}
